import { isPresent } from "@/utils/validation";

export function formatVariation(variation) {
  return isPresent(variation) ? variation : "+ ∞";
}
